import React, { SVGProps } from 'react'
export const FirstActiveRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 35c6.966-.914 12.779-2.866 14.255-7.018C16.966 20.36 19.06 9.06 0 4v31Z"
    />
  </svg>
)
